// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3JbT3","col":"styles_col__3QyS5","fulfillmentStatus":"styles_fulfillmentStatus__2N4-s","emailCol":"styles_emailCol__1L2GE"};